import styled, { css, keyframes } from 'styled-components';

//@todo: Reimplement this in TW once it supports animation
const cubicBezier = `cubic-bezier(0.23, 1, 0.32, 1)`;

const slideIn = keyframes`
  0% {
    transform: translateX(100%);
    opacity: 0;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
`;
const slideOut = keyframes`
  0% {
    transform: translateX(0%);
    opacity: 1;
  }
  100% {
    transform: translateX(100%);
    opacity: 0;
  }
`;

export const SidePanelAnimation = styled('div')<{
  isOpen: boolean;
  duration: number;
}>`
  ${({ isOpen, duration }) => {
    if (isOpen) {
      return css`
        translateX(0%);
        animation: ${slideIn} ${duration}ms ${cubicBezier};
      `;
    }

    return css`
      translateX(100%);
      animation: ${slideOut} ${duration}ms ${cubicBezier};
    `;
  }}
`;
